import { init } from "boltz-core/liquid";
import Loader from "boltz-swaps/lazy";
import { confidential } from "liquidjs-lib";

export default new Loader("Secp256k1ZKP", async () => {
    const zkp = (await import("@vulpemventures/secp256k1-zkp")).default;
    const secp = await zkp();

    init(secp);
    return {
        secpZkp: secp,
        confidential: new confidential.Confidential(secp as never),
    };
});
